import React, { Component } from "react";
import LoginForm from "./LoginForm";
import { PATHS } from "../../constant";
import LoginDesc from "./LoginDesc";
import ForgetForm from "./ForgetForm";
import { withCookies } from "react-cookie";
import backButton from "../../assets/back-button.png";

class Login extends Component {
  state = {
    forgetFormStatus: false
  };

  handleForget = () => {
    const { forgetFormStatus } = this.state;
    this.setState({
      forgetFormStatus: !forgetFormStatus
    });
  };

  render() {
    const { cookies, history } = this.props;
    const { forgetFormStatus } = this.state;
    return (
      <React.Fragment>
        <div className="signup user-login">
          <div className="login-register-tabs">
            <button className="login-btn active">Login</button>
            <button
              className="register-btn"
              onClick={() => history.push(PATHS.SIGNUP)}
            >
              Register
            </button>
          </div>

          <div className="register-outer">
            {/* <img
              src={backButton}
              alt="Back"
              className="back-btn"
              onClick={() => history.push(PATHS.LOGIN)}
            /> */}
            {forgetFormStatus ? (
              <ForgetForm
                handleLoginWithPassword={this.handleLoginWithPassword}
                handleForget={this.handleForget}
              />
            ) : (
              <LoginForm cookies={cookies} handleForget={this.handleForget} />
            )}
          </div>
          <div className="no-account">
            <LoginDesc
              accountHeading="Don't have an account?"
              buttonText="Register"
              subHeading="Register Now"
              buttonLink="/register"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withCookies(Login);
